import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchExerciseMin } from "../../../redux/slices/optionsSlice";
import { replaceExercise } from "../../../redux/slices/customer/trainingSlice";

const ReplaceExerciseModal = ({ isOpen, onClose, selectedExerciseParent, week_number, day_number }) => {
  const dispatch = useDispatch();
  const exercises_min = useSelector((state) => state.app_options?.exercises_min);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedExercise, setSelectedExercise] = useState(null);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [exercisesData, setExercisesData] = useState([]);

  useEffect(() => {
    if (Array.isArray(exercises_min)) {
      setExercisesData(exercises_min);
    }
  }, [exercises_min]);

useEffect(() => {
  if (isOpen) {
    dispatch(fetchExerciseMin({ searchTerm: "", old_exercise_id: selectedExerciseParent }));
  } else {
    setSearchTerm("");
    setSelectedExercise(null);
    setIsDropdownVisible(false);
    setExercisesData([]);
  }
}, [isOpen, dispatch, selectedExerciseParent]);

  const handleSearch = (event) => {
    const term = event.target.value;
    setSearchTerm(term);
    if (term.trim()) {
      dispatch(fetchExerciseMin({ searchTerm: term, old_exercise_id:selectedExerciseParent }));
      setIsDropdownVisible(true);
    } else {
      setIsDropdownVisible(false);
    }
  };

  const handleSelectExercise = (exerciseId, exerciseName) => {
    setSelectedExercise(exerciseId);
    setSearchTerm(exerciseName);
    setIsDropdownVisible(false);
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (selectedExercise) {
      var p = { old_exercise_id:selectedExerciseParent, new_exercise_id:selectedExercise, 'week_number':week_number, 'day_number':day_number};  
      dispatch(replaceExercise(p));
      onClose();
    }
  };

  return isOpen ? (
    <div
      className="modal fade show replace-exercise-modal"
      style={{ display: "block" }}
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header justify-content-center">
            <h5 className="modal-title">Replace Exercise</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSave}>
              <div className="w-100 mt-4">
               <label className="inputLabel mb-2" htmlFor="exercise-select">
  Select Exercise
</label>
<select
  id="exercise-select"
  className="form-control"
  value={selectedExercise || ""}
  onChange={(e) => {
    const selectedId = e.target.value;
    const selectedObj = exercisesData.find((ex) => ex.id == selectedId);
    setSelectedExercise(selectedId);
    setSearchTerm(selectedObj?.training_name || "");
  }}
>
  <option value="">-- Select an Exercise --</option>
  {exercisesData.map((exercise) => (
    <option key={exercise.id} value={exercise.id}>
      {exercise.training_name} ({exercise.category_name_display})
    </option>
  ))}
</select>
              </div>
              <div className="form-group mb-0 mt-4">
                <button
                  type="submit"
                  className="btn-curve w-100"
                  disabled={!selectedExercise} // Disable save if no exercise is selected
                >
                  Replace
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default ReplaceExerciseModal;